
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/freecreditevaluation/privacy-policy",
      function () {
        return require("private-next-pages/freecreditevaluation/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/freecreditevaluation/privacy-policy"])
      });
    }
  